import React, { CSSProperties, useEffect, useState } from 'react';
import { IoChatbubbleOutline, IoMapOutline } from "react-icons/io5";
import { MdWorkspacesOutline } from "react-icons/md";
import { LuCircleUserRound, LuKanban } from "react-icons/lu";
import { BsBell, BsCreditCard } from "react-icons/bs";
import { useAppSelector, useAppDispatch } from '../../Core/hooks';
import { getRoadmap } from '../../Store/Roadmap';
import { getSettings, toggleChat, toggleSidebar } from '../../Store/Settings';
import { loadComponent } from '../../Store/Settings';
import { handleLoadComponent } from '../../Helpers/handleLoadComponent';
import { getFolder, setFolderStatus } from '../../Store/Folder';
import { BsToggleOn, BsToggleOff } from "react-icons/bs";
import { getChat } from '../../Store/Chat';
import { getUser } from '../../Store/Auth';
import { openSocket } from '../../Helpers/openSocket';
import { SettingsContextParam } from "../../Models/Requests/SettingsContextParam";
import { BillingContextMenuParam } from '../../Models/Requests/BillingContexMenuParam';
import BillingContextMenu from '../../Modals/BillingContextMenu';
import SettingsContext from "../../Modals/SettingsContext";

function RoadmapNav() {

    const dispatch = useAppDispatch();
    const folderState = useAppSelector(getFolder);
    const settingsState = useAppSelector(getSettings);
    const roadmapState = useAppSelector(getRoadmap);
    const chatState = useAppSelector(getChat);
    const userState = useAppSelector(getUser);
    const [settingsContextParams, setSettingsContextParams] = useState<SettingsContextParam>();
    const [billingContextMenuParams, setBillingContextMenuParams] = useState<BillingContextMenuParam>();

    const handleLoadRoadmapList = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        handleLoadComponent(dispatch, settingsState.settings.previousComponentType, settingsState.settings);
        /* Maps icon should either load the roadmaps home, i.e. global_maps, or 
           if the user is setting in chat it needs to load whatever work they
           are working on, that way they can quickly toggle between chat and work
         */
        if(settingsState.settings.loadedComponentType !== "chat") {
            handleLoadComponent(dispatch, "global_maps", settingsState.settings); 
        } else {
            if(settingsState.settings.previousComponentType !== "chat") {
                handleLoadComponent(dispatch, settingsState.settings.previousComponentType, settingsState.settings);
            } else {
                handleLoadComponent(dispatch, "global_maps", settingsState.settings); 
            }
        }
    }

    const handleLoadChat = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        handleLoadComponent(dispatch, "chat", settingsState.settings);       
    }

    const handleToggleSidebar = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        dispatch(toggleSidebar(!settingsState.settings.sidebarExpanded));
    }

    const handleShowBilling = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        setBillingContextMenuParams({ id: '1', event: e }); 
    }

    const popSettingsWindow = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
       // e.stopPropagation();
        setSettingsContextParams({ _id: "1", event: e }); 
    }

    let navItemStyle = { 
        cursor: "pointer",
        paddingTop: "5px", 
        fontSize: "8pt", 
        color: "#F8F9FA", 
        fontWeight: "450",
    };

    let navItemSelectedStyle = {
        cursor: "pointer",
        paddingTop: "5px", 
        fontSize: "8pt",  
        fontWeight: "450",
        color: "#e55c02",
        textDecoration: "underline",
        textUnderlineOffset: "5px",
        textDecorationThickness: "1px",
    };

    let mapsTabLoaded = settingsState.settings.loadedComponentType !== "chat";
    let mapsIconColor = (mapsTabLoaded) ? "#e55c02" : "#bec1c3";
    let mapsDivStyle: CSSProperties = (mapsTabLoaded) ? navItemSelectedStyle : navItemStyle;

    let chatTabLoaded = settingsState.settings.loadedComponentType === "chat";
    let chatIconColor = (chatTabLoaded) ? "#e55c02" : "#bec1c3";
    let chatDivStyle: CSSProperties = (chatTabLoaded) ? navItemSelectedStyle : navItemStyle;

    let unreadMessages = 0;
    for (const channel of chatState.channels) {
        let messages = chatState.messages.filter(m => m.channelId === channel._id);
        messages.forEach(message => {
            if(!channel.loaded && 
                message.userId !== userState._id && (
                message.channelId === channel._id && new Date(message.modified) > new Date(channel.lastUnloaded)) ||
                (message.channelId === channel._id && !channel.lastLoaded)) {
                unreadMessages++;
            }
            if (channel.loaded && settingsState.settings.loadedComponentType !== "chat") {
                if (message.userId !== userState._id && message.channelId === channel._id && 
                    new Date(message.modified) > new Date(settingsState.settings.lastComponentTypeSwitch)
                ) {
                    unreadMessages++;
                }
            }
        });
    }
//
    return (
    <>
        <div style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            width: '100%',
            backgroundColor: '#02152a',
            zIndex: 999,
            height: "50px",
            display: 'flex',
            justifyContent: 'center',  // horizontal centering
            alignItems: 'center'       // vertical centering
          }}>
            {/*
            <div style={{ cursor: "pointer", paddingBottom: "20px" }} onClick={(e) => handleToggleSidebar(e)}>
                {settingsState.settings.sidebarExpanded ?
                    <BsToggleOn size={25} color="#bec1c3" />
                :
                    <BsToggleOff size={25} color="#bec1c3" />
                }
            </div>
            */}
            <div style={{ display: "inline-block", paddingRight: "25px" }}>
                <div style={{ cursor: "pointer" }} onClick={(e) => handleLoadRoadmapList(e)}>
                    <IoMapOutline color={mapsIconColor} size={25} />
                </div>
            </div>
            <div style={{ display: "inline-block", paddingRight: "25px" }}>
                <div style={{ cursor: "pointer" }} onClick={(e) => handleLoadChat(e)}>
                    <IoChatbubbleOutline color={chatIconColor} size={25} />
                </div>
            </div>
            {unreadMessages > 0 &&
                <div style={{ position: "relative", top: "-5px", left: "-30px", color: "#fff", fontSize: "8pt", 
                    backgroundColor: "#ca0117", borderRadius: "50%", width: "17px", height: "17px",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.3)"
                }}>
                    <span style={{ position: "relative", top: "-1px", left: "5px", fontWeight: "500" }}>
                        {unreadMessages}
                    </span>
                </div>
            }
            <div style={{ display: "inline-block", paddingRight: "25px" }} 
                onClick={(e) => handleShowBilling(e)}>
                <div style={{ cursor: "pointer" }}>
                    <BsCreditCard color="#bec1c3" size={25} />
                </div>
            </div>
            <div style={{ display: "inline-block" }} onClick={(e) => popSettingsWindow(e)}>
                <div style={{ cursor: "pointer" }}>
                    <LuCircleUserRound color="#bec1c3" size={25} />
                </div>
            </div>
        </div>
        <SettingsContext params={settingsContextParams} />
        <BillingContextMenu params={billingContextMenuParams} />    
    </>
    );
}

export default RoadmapNav;